<div class="main-container">
  <!-- Header Section -->
  <div class="page-header">
    <div class="routing-buttons">
      <div
        class="action-button back-button"
        (click)="navigateBack()"
        tabindex="0"
        (keydown.enter)="navigateBack()"
      >
        <mat-icon class="icon back-icon">arrow_back</mat-icon>
      </div>
      <div
        class="action-button reload-button"
        (click)="ngOnInit()"
        tabindex="0"
        (keydown.enter)="ngOnInit()"
      >
        <mat-icon class="icon reload-icon">refresh</mat-icon>
      </div>
      <span class="page-title"> FOTA Batch </span>
    </div>
    <div class="page-info">
      <div class="header">Number of Devices Under Regular Bulk FOTA:</div>
      {{ numberOfFOTAInitiatedCount }}
      <div class="header">
        <div class="button-group">
          <button
            type="button"
            class="primary-button"
            (click)="numberOfFOTAInitiated()"
          >
            <mat-icon class="btn-icon">refresh</mat-icon>
          </button>

          <button
            class="primary-button"
            type="button"
            [disabled]="isDownloading"
            (click)="downloadAllFOTAInitiatedDevicesReport()"
          >
            <mat-icon class="btn-icon">download</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="button-group">
      <button class="primary-button" type="button" (click)="fotaBatchReport()">
        FOTA Batch Report <mat-icon class="btn-icon">open_in_new</mat-icon>
      </button>
      @if (createFota) {
        <button class="primary-button" type="button" (click)="createNew()">
          Create New Batch <mat-icon class="btn-icon">open_in_new</mat-icon>
        </button>
      }
      @if (viewManualFota) {
        <button class="primary-button" type="button" (click)="manualFOTANew()">
          Manual FOTA <mat-icon class="btn-icon">open_in_new</mat-icon>
        </button>
      }
      <app-fota-info></app-fota-info>
    </div>
  </div>

  <div class="component-container">
    <form [formGroup]="deviceFOTAForm" novalidate>
      <div class="component-header">
        <h6 class="component-title">FOTA Batch List</h6>
        <div class="component-actions">
          <app-common-search
            [initialSearchValue]="deviceFOTAForm?.get('batchListSearch')?.value"
            matTooltip="Batch ID | Batch Name | Batch Description | Batch.UIN | Batch.IMEI"
            (searchSubmit)="onSearch($event)"
          ></app-common-search>
        </div>
      </div>

      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>Batch ID</th>
              <th>Batch Name</th>
              <th>Batch Description</th>
              <th>Batch Type</th>
              <th>Created By</th>
              <th>Created At</th>
              <th>Batch Breakdown</th>
              <th>Completed Percentage</th>
              <th>Batch Status</th>
              <th>Action</th>
            </tr>
          </thead>
          @if (listOfBatch.length !== 0) {
            <tbody>
              @for (
                deviceValue of listOfBatch
                  | paginate
                    : {
                        id: 'batchPaginate',
                        itemsPerPage: size,
                        currentPage: page,
                        totalItems: totalLength,
                      };
                track deviceValue
              ) {
                <tr>
                  <td>{{ deviceValue.batchId }}</td>
                  <td>{{ deviceValue.name }}</td>
                  <td>{{ deviceValue.description }}</td>
                  <td>{{ deviceValue.ais140 ? 'AIS140' : 'Regular' }}</td>
                  <td>
                    {{
                      deviceValue.createdByName
                        ? deviceValue.createdByName
                        : '--'
                    }}
                  </td>
                  <td>
                    {{
                      deviceValue.createdAt | date: 'dd MMM yyyy | hh:mm:ss a'
                    }}
                  </td>
                  <td>
                    C =
                    {{ (deviceValue.completedDevices | indianNumber) || 0 }} ||
                    A =
                    {{ (deviceValue.abortedDevices | indianNumber) || 0 }} || IP
                    =
                    {{ (deviceValue.inProgressDevices | indianNumber) || 0 }} ||
                    P =
                    {{ (deviceValue.pendingDevices | indianNumber) || 0 }} || T
                    =
                    {{ (deviceValue.totalDevices | indianNumber) || 0 }}
                  </td>
                  <td>
                    {{
                      (deviceValue.totalDevices
                        ? ((deviceValue.completedDevices +
                            deviceValue.abortedDevices) /
                            deviceValue.totalDevices) *
                          100
                        : 100
                      ) | number: '1.2-2'
                    }}
                    %
                  </td>
                  <td
                    [matTooltip]="getDurationTooltip(deviceValue)"
                    matTooltipClass="multi-line-tooltip"
                    matTooltipPosition="above"
                  >
                    @if (deviceValue.status === 'Not-Started') {
                      <div class="status-container">
                        Not Started
                        <mat-icon class="gray btn-icon" matTooltip="Not started"
                          >circle</mat-icon
                        >
                      </div>
                    } @else if (deviceValue.status === 'In-Progress') {
                      <div class="status-container">
                        In-progress
                        <mat-icon
                          class="orange btn-icon"
                          matTooltip="In-progress"
                          >circle</mat-icon
                        >
                      </div>
                    } @else if (deviceValue.status === 'Aborted') {
                      <div class="status-container">
                        Aborted
                        <mat-icon class="red btn-icon" matTooltip="Aborted"
                          >circle</mat-icon
                        >
                      </div>
                    } @else if (deviceValue.status === 'Completed') {
                      <div class="status-container">
                        Completed
                        <mat-icon class="green btn-icon" matTooltip="Completed"
                          >circle</mat-icon
                        >
                      </div>
                    }
                  </td>
                  <td>
                    <div class="action-buttons">
                      @if (viewFotaBatch) {
                        <button
                          class="primary-button view-button"
                          type="button"
                          (click)="view(deviceValue._id)"
                        >
                          <mat-icon class="btn-icon">visibility</mat-icon>
                        </button>
                      }
                      @if (deleteFota) {
                        <button
                          type="button"
                          class="primary-button abort-button"
                          [disabled]="
                            deviceValue.status === 'Completed' ||
                            deviceValue.status === 'Aborted' ||
                            (deviceValue.totalDevices &&
                              ((deviceValue.completedDevices +
                                deviceValue.abortedDevices) /
                                deviceValue.totalDevices) *
                                100 ===
                                100)
                          "
                          (click)="deleteFotaBatchDetails(deviceValue)"
                        >
                          <mat-icon class="btn-icon">block</mat-icon>
                        </button>
                      }
                      <button
                        type="button"
                        class="primary-button export-button"
                        [disabled]="isDownloading"
                        (click)="downloadFotaBatchDeviceReport(deviceValue._id)"
                      >
                        <mat-icon class="btn-icon"> file_download</mat-icon>
                      </button>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          }
          @if (listOfBatch.length === 0) {
            <tbody>
              <tr>
                <td colspan="9">
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>
      <!-- Separator between Body and Footer -->
      <div class="component-separator"></div>

      <!-- Component Footer Section (Optional) -->
      <div class="component-footer">
        @if (listOfBatch.length !== 0) {
          <app-common-component-pagination
            [totalItems]="totalLength"
            [pageSize]="size"
            [currentPage]="page"
            [totalPages]="totalLength"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </form>
  </div>
</div>
